import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  Check,
  CreditCard,
  Dumbbell,
  Lock,
  ShieldCheck,
  Sparkles,
  Wallet,
  Zap,
} from "lucide-react";

const API_URL = process.env.REACT_APP_API_URL || "https://api.mogym.ir";

const messages = [
  "در حال آماده‌سازی فعالسازی برنامه...",
  "در حال ذخیره اطلاعات برنامه اختصاصی شما...",
  "در حال ساخت درخواست پرداخت امن...",
  "چند لحظه دیگر به پرداخت منتقل میشی...",
];

export default function PaymentPreparingPage() {
  const navigate = useNavigate();
  const location = useLocation();

const form =
  location?.state?.form ||
  safeJsonParse(localStorage.getItem("campaignWizardForm"));

const analysis =
  location?.state?.analysis ||
  safeJsonParse(localStorage.getItem("campaignAnalysis"));

const preview = location?.state?.preview || null;

const mobileNumber =
  location?.state?.mobileNumber ||
  localStorage.getItem("campaignMobileNumber") ||
  "";

const planGuid =
  location?.state?.planGuid ||
  localStorage.getItem("campaignPlanGuid") ||
  "";

const token =
  location?.state?.token ||
  localStorage.getItem("campaignToken") ||
  "";

  const [progress, setProgress] = useState(8);
  const [messageIndex, setMessageIndex] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [error, setError] = useState("");

const payload = useMemo(
  () => ({
    Id:planGuid
  }),
  [planGuid]
);

  useEffect(() => {
    const msgTimer = setInterval(() => {
      setMessageIndex((p) => (p + 1) % messages.length);
    }, 1100);

    const progressTimer = setInterval(() => {
      setProgress((p) => Math.min(p + 7, 96));
    }, 260);

    const stepTimer = setInterval(() => {
      setCurrentStep((s) => Math.min(s + 1, 3));
    }, 850);

    startPayment();

    return () => {
      clearInterval(msgTimer);
      clearInterval(progressTimer);
      clearInterval(stepTimer);
    };
  }, []);

  const startPayment = async () => {
    try {
      setError("");

const res = await fetch(`${API_URL}/api/campaign/body-analysis/start-payment`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
  body: JSON.stringify(payload),
});

const data = await res.json();

if (!res.ok) {
  throw new Error(data?.message || data?.Message || "خطا در ساخت پرداخت");
}


      await new Promise((r) => setTimeout(r, 3200));

      setProgress(100);
      setCurrentStep(3);

            const redirectUrl =
        data?.redirectUrl ??
        data?.RedirectUrl ??
        data?.result?.redirectUrl ??
        data?.Result?.RedirectUrl;

      if (res.ok && redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }

    } catch (e) {
      setError(e?.message || "خطا در آماده‌سازی پرداخت");
    }
  };

  return (
    <main dir="rtl" className="font-vazir relative min-h-screen overflow-hidden bg-[#030712] text-white">
      <div className="fixed inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(16,185,129,.36),transparent_34%),radial-gradient(circle_at_0%_85%,rgba(37,99,235,.30),transparent_38%),radial-gradient(circle_at_100%_70%,rgba(34,211,238,.18),transparent_30%)]" />
      <div className="fixed inset-0 opacity-[.15] bg-[linear-gradient(rgba(255,255,255,.08)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.08)_1px,transparent_1px)] bg-[size:34px_34px]" />
      <div className="fixed inset-0 bg-gradient-to-b from-transparent via-[#030712]/30 to-[#030712]" />

      <section className="relative z-10 mx-auto flex min-h-screen max-w-md flex-col px-5 py-6">

        <div className="flex flex-1 flex-col items-center justify-center text-center">
          <div className="relative h-[310px] w-[310px]">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ repeat: Infinity, duration: 18, ease: "linear" }}
              className="absolute inset-0 rounded-full border border-emerald-300/15"
            />

            <motion.div
              animate={{ rotate: -360 }}
              transition={{ repeat: Infinity, duration: 25, ease: "linear" }}
              className="absolute inset-8 rounded-full border border-cyan-300/15"
            />

            <motion.div
              animate={{
                scale: [1, 1.12, 1],
                opacity: [0.45, 0.95, 0.45],
              }}
              transition={{ repeat: Infinity, duration: 2.2 }}
              className="absolute inset-16 rounded-full bg-gradient-to-br from-emerald-300 via-cyan-300 to-blue-500 blur-2xl"
            />

            <div className="absolute inset-12 rounded-full border border-white/10 bg-black/40 shadow-[0_0_120px_rgba(52,211,153,.38)] backdrop-blur-2xl" />

            <div className="absolute inset-0 grid place-items-center">
              <div>
                <div className="mx-auto grid h-20 w-20 place-items-center rounded-[28px] bg-emerald-300 text-black shadow-[0_0_60px_rgba(52,211,153,.55)]">
                  <Wallet size={38} />
                </div>

                <div className="mt-5 text-5xl font-black">
                  {progress}%
                </div>

                <div className="mt-2 text-[11px] text-white/45">
                  ACTIVATING PLAN
                </div>
              </div>
            </div>

            <FloatingChip className="right-0 top-20" icon={Dumbbell} text="برنامه" />
            <FloatingChip className="left-3 top-28" icon={ShieldCheck} text="امن" />
            <FloatingChip className="right-8 bottom-16" icon={Lock} text="ذخیره" />
            <FloatingChip className="left-8 bottom-8" icon={CreditCard} text="پرداخت" />
          </div>

          <AnimatePresence mode="wait">
            <motion.h1
              key={messageIndex}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -14 }}
              className="mt-6 text-2xl font-black leading-9"
            >
              {messages[messageIndex]}
            </motion.h1>
          </AnimatePresence>

          <p className="mt-4 max-w-xs text-sm leading-7 text-white/58">
            برنامه اختصاصی تو آمادست؛ داریم مسیر فعالسازی و پرداخت امن را آماده می‌ کنیم
          </p>

          <div className="mt-8 w-full space-y-3">
            <Step done={currentStep >= 0} active={currentStep === 0} text="تحلیل تکمیل شد" />
            <Step done={currentStep >= 1} active={currentStep === 1} text="اطلاعات برنامه ذخیره شد" />
            <Step done={currentStep >= 2} active={currentStep === 2} text="درخواست پرداخت ساخته شد" />
            <Step done={currentStep >= 3} active={currentStep === 3} text="آماده انتقال به پرداخت" />
          </div>

          {error && (
            <div className="mt-6 w-full rounded-2xl border border-red-400/20 bg-red-500/10 px-4 py-3 text-center text-sm text-red-300">
              {error}
            </div>
          )}

          {error && (
            <button
              onClick={startPayment}
              className="mt-4 h-14 w-full rounded-2xl bg-emerald-400 font-black text-black"
            >
              تلاش دوباره
            </button>
          )}
        </div>
      </section>
    </main>
  );
}

function Step({ done, active, text }) {
  return (
    <div
      className={`flex items-center gap-3 rounded-2xl border px-4 py-3 backdrop-blur-2xl ${
        done
          ? "border-emerald-400/20 bg-emerald-400/10"
          : "border-white/10 bg-white/[.045]"
      }`}
    >
      <div
        className={`grid h-8 w-8 place-items-center rounded-full ${
          done ? "bg-emerald-300 text-black" : "bg-white/8 text-white/40"
        }`}
      >
        {done ? <Check size={17} /> : <Zap size={15} />}
      </div>

      <span className="flex-1 text-sm font-bold text-white/75">{text}</span>

      {active && (
        <span className="h-2 w-2 animate-pulse rounded-full bg-cyan-300 shadow-[0_0_16px_rgba(103,232,249,.8)]" />
      )}
    </div>
  );
}

function FloatingChip({ icon: Icon, text, className }) {
  return (
    <motion.div
      animate={{ y: [0, -8, 0] }}
      transition={{ repeat: Infinity, duration: 3.5 }}
      className={`absolute flex items-center gap-2 rounded-2xl border border-white/10 bg-black/35 px-3 py-2 text-[11px] text-white/70 shadow-xl backdrop-blur-2xl ${className}`}
    >
      <Icon size={15} className="text-emerald-300" />
      {text}
    </motion.div>
  );
}

function safeJsonParse(value) {
  try {
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
}